module.exports = __webpack_public_path__ + "static/media/cheng-detail-title-icon.36d456f6.png";